import { VisualScreen } from 'app/frontend/types/custom/VisualPlan'
import { AssignmentViewMode } from './assignmentTimeline'

export type NumberedVisualScreen = {
  screen: VisualScreen
  number: number
}

export const getActiveVisualScreens = (
  screens: VisualScreen[],
  visualScreenIds?: string[],
): NumberedVisualScreen[] => {
  const activeIds = visualScreenIds ? new Set(visualScreenIds) : undefined
  return screens
    .map((screen, index) => ({ screen, number: index + 1 }))
    .filter(({ screen }) => !activeIds || activeIds.has(screen.id))
}

type GetScopeScreensInput = {
  viewMode: AssignmentViewMode
  scopeId: string
  scopeIndex: number
  activeScreens: NumberedVisualScreen[]
}

export const getScopeScreens = ({
  viewMode,
  scopeId,
  scopeIndex,
  activeScreens,
}: GetScopeScreensInput): NumberedVisualScreen[] => {
  if (activeScreens.length === 0) return []
  if (viewMode === 'all_together') return activeScreens
  if (viewMode === 'all_separate') {
    return [activeScreens[scopeIndex % activeScreens.length]]
  }
  const parity = scopeId === 'even' ? 1 : 0
  return activeScreens.filter((_, index) => index % 2 === parity)
}
